import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, ApiResponse, ClientFeedSubscriptionModel, FeedPriceTypesEnum, MarketDataFeedBundleInterface, SesHelper, SesService, UserCategoryTypesEnum} from '@spa/api';
import {CreateSubscriptionForm} from 'appEntries/panel/forms';
import {MarketDataFeedSubscriptionFormErrorStatesEnum, MarketDataFeedUserTypesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedSubscriptionMessages} from 'appAssets/messages'; 
import {PanelBaseMarketDataDialogComponent} from '../panel-base-market-data-dialog.component';
import {AlertsService, CurrencyService} from 'appShared/services';
import {AlertTypesEnum} from 'appShared/enums';

@Component({
    selector: 'app-market-data-create-subscription',
    templateUrl: './market-data-create-subscription.component.html',
    styleUrls: ['./market-data-create-subscription.component.scss']
})
export class MarketDataCreateSubscriptionComponent extends PanelBaseMarketDataDialogComponent<MarketDataCreateSubscriptionComponent> {
    @Input() public clientAccountAndBundleData: ClientFeedSubscriptionModel;
    @Input() public bundles: MarketDataFeedBundleInterface[];
    @Input() public userType: MarketDataFeedUserTypesEnum;
    @Input() public userCategoryType: UserCategoryTypesEnum;
    @Input() public offsetAccountId: string;
    public totals: {currency: string, totalNonProPrice: number, totalProPrice: number}[] = [];

    public isProUser: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            bundles: MarketDataFeedBundleInterface[],
            clientAccountAndBundleData: ClientFeedSubscriptionModel,
            userType: MarketDataFeedUserTypesEnum,
            userCategoryType: UserCategoryTypesEnum,
            offsetAccountId: string,
        },
        public dialogRef: MatDialogRef<MarketDataCreateSubscriptionComponent>,
        private readonly sesService: SesService,
        private readonly alertsService: AlertsService,
        private readonly currencyService: CurrencyService,
    ) {
        super(dialogRef);
        this.config = data.config;
        this.bundles = data.bundles;
        this.clientAccountAndBundleData = data.clientAccountAndBundleData;
        this.userType = data.userType;
        this.userCategoryType = data.userCategoryType;
        this.offsetAccountId = data.offsetAccountId;
        this.isProUser = this.userCategoryType === UserCategoryTypesEnum.Pro;
        this.isServiceUser = this.userType === MarketDataFeedUserTypesEnum.ServiceUser;
    }

    handleErrorResponse(response: ApiResponse<ApiError[] | boolean>) {
        (response.data as ApiError[]).map((error: ApiError) => {
            if (Array.isArray(response.messages) && response.messages[0]) {
                return response.messages[0];
            }

            if (error.status === MarketDataFeedSubscriptionFormErrorStatesEnum.CreateMarketDataFeedSubscriptionFailed) {
                return MarketDataFeedSubscriptionMessages.CreateMarketDataFeedSubscriptionFailed.message;
            }

            return MarketDataFeedSubscriptionMessages.UnknownError.message;
        }).filter((errorMessage: string) => {
            return errorMessage.trim();
        }).forEach((errorMessage: string) => {
            this.alertsService.addAlert(errorMessage);
        });
    }

    showSuccessFormMessage(): void {
        this.alertsService.addAlert(
            MarketDataFeedSubscriptionMessages.CreateMarketDataFeedSubscriptionSuccess.message,
            AlertTypesEnum.Success
        );
    }

    initForm(): void {
        this.form = new CreateSubscriptionForm(this.sesService, this.currencyService, this.bundles, this.clientAccountAndBundleData, this.offsetAccountId);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const bundlePrefix = (this.form as CreateSubscriptionForm).FEEDID_CHECKBOX_PREFIX;
            const selectedBundles = [];
            for (const key of Object.keys(data)) {
                const bundleId = data[key];
                if (key.startsWith(bundlePrefix) && bundleId > 0) {
                    selectedBundles.push(bundleId);
                }
            }
            this.calculateTotals(selectedBundles);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundles.length === 0
        });

        this.subscriptions.push(formChangeSubscription);
    }

    calculateTotals(checkedBundles: number[]): void { 
        const currentBundles = this.bundles.filter(d => checkedBundles.includes(d.id));
        this.totals = [];
        if(currentBundles && currentBundles.length > 0){
            currentBundles.forEach(bundle => {
                const totalPro = SesHelper.getPriceDataBy(bundle.priceList, FeedPriceTypesEnum.SelfPro, false).price;  
                const totalNonPro =  SesHelper.getPriceDataBy(bundle.priceList, FeedPriceTypesEnum.SelfNonPro, false).price;
                const currency =  SesHelper.getPriceCurrency(bundle.priceList);
                let currencyBundle = this.totals.find(c => c.currency == currency);  
                if(!currencyBundle){
                    currencyBundle = {currency:  currency as string, totalNonProPrice: totalNonPro, totalProPrice:totalPro as number};
                    this.totals.push(currencyBundle);
                    return;
                }
                currencyBundle.totalProPrice += totalPro;
                currencyBundle.totalNonProPrice += totalNonPro; 
            });
        }
    }
}
